const module = {
  routes: [
    {
      path: '/tools/export',
      component: () => import('@/modules/export/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
